import React, { memo, useCallback, useState } from 'react'

import {
  Button, classnames, Collapse3, Copy, Expand3, Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import useIsClamped from './useIsClamped'

const controlIconSize = { height: '16px', width: '16px' }
const expandIcon = <Icon svgComponent={Expand3} size={controlIconSize} color="darker" notSpaced />
const collapseIcon = <Icon svgComponent={Collapse3} size={controlIconSize} color="darker" notSpaced />
const copyIcon = <Icon svgComponent={Copy} size={controlIconSize} color="darker" notSpaced />

// The prompt is clamped to two lines until expanded.
function Prompt({ text = '' }) {
  const t = useTranslation()
  const [isExpanded, setIsExpanded] = useState(false)
  const [textRef, isClamped] = useIsClamped(text, isExpanded)

  const handleToggle = useCallback(() => setIsExpanded(expanded => !expanded), [])

  // The Clipboard API is absent outside a secure context, so the control does nothing there
  // rather than throwing on click.
  const handleCopy = useCallback(() => {
    navigator.clipboard?.writeText(text)
  }, [text])

  if (!text) return null

  return (
    <div className="image-gallery-modal__prompt">
      <div className="image-gallery-modal__prompt-header">
        <span className="image-gallery-modal__prompt-label cgt-body-base-semibold">
          {t('imageGallery.modal.prompt')}
        </span>
        <div className="image-gallery-modal__prompt-controls">
          {(isClamped || isExpanded) && (
            <Button
              type="ghost"
              size="tiny"
              variant="only-icon"
              actionType="button"
              icon={isExpanded ? collapseIcon : expandIcon}
              customClass="image-gallery-modal__prompt-control"
              onClick={handleToggle}
              aria-expanded={isExpanded}
              aria-label={t(isExpanded ? 'imageGallery.modal.collapsePrompt' : 'imageGallery.modal.expandPrompt')}
            />
          )}
          <Button
            type="ghost"
            size="tiny"
            variant="only-icon"
            actionType="button"
            icon={copyIcon}
            customClass="image-gallery-modal__prompt-control"
            onClick={handleCopy}
            aria-label={t('imageGallery.modal.copyPrompt')}
          />
        </div>
      </div>
      <p
        ref={textRef}
        className={classnames(
          'image-gallery-modal__prompt-text cgt-body-base',
          !isExpanded && 'image-gallery-modal__prompt-text--clamped',
        )}
      >
        {text}
      </p>
    </div>
  )
}

Prompt.propTypes = {
  text: string,
}

export default memo(Prompt)
